<template>
    <div id="aboutCashOut">
        <Headers :headersText='headersText'></Headers>
        <div class="boxPadding">
            <div class="explain">
                <div class="text">
                    <div class="content">尊敬的用户，感谢您使用钱大师网络平台服务。本协议是由您与西安九点整软件科技有限公司（以下简称为“我们”或“钱大师”）就钱大师网络平台服务（包括我们现在正在提供和将来可能向您提供的平台服务，以下统称为“平台服务”）所订立的协议。</div><br />
                    <div class="title">本协议为我们单方设定的“格式合同”，您应仔细阅读并理解协议内容，特别是协议内容中加粗部分，我们有义务对协议中的所有条款进行解释或说明。<span class="content">如您获得并使用我们所提供的平台服务（包括但不仅限于下载、登陆、查看等行为），即视为您已经详细阅读并同意受本协议的约束。</span></div><br>
                    <div class="content">钱大师有权在必要时修改本协议条款。您可以在相关页面中查阅最新的协议条款。本协议条款变更后，如您继续使用本服务，即视为您已接受修改后的条款。如您不接受修改后的协议，应当立即停止使用本产品及服务。</div><br>
                    
                    <div class="title">一、关于服务内容</div>
                    <div class="content">（1）我们服务的具体内容由我们根据实际情况提供。保留随时变更、中断或终止部分或全部平台服务的权利。
                        <br>（2）用户理解：钱大师仅提供相关的平台服务，除此之外与相关平台服务有关的设备(如电脑、调制解调器及其他与接入互联网有关的装置)及所需的费用(如为接入互联网而支付的电话费、上网费及下载个别应用所支付的费用)均应由用户自行负担。
                        <br>（3）用户应使用正版软件接受平台服务。
                        <br>（4）您在钱大师下载第三方应用或体验第三方服务前，应充分了解第三方产品及服务可能带来的风险，您下载第三方应用、体验第三方服务均属您个人行为，由您个人行为造成的危害、损失需要您自行承担责任。</div><br>
                    
                    <div class="title">二、有关个人资料</div>
                    <div class="content">1.提供个人资料      
                        <br>（1）在填写资料时，请保持这些信息的及时更新，以便我们向您提供帮助，或更好地为您提供服务。若国家法律法规有特殊规定的，您需要填写真实的身份信息。若您填写的信息不完整或不准确，则可能无法使用服务或者在使用过程中受到限制。
                        <br>（2）所有由您提供的个人资料将被我们用来作为识别您和其他用户的依据；
                        <br>（3）如果您所提供的个人资料与事实不符，或已变更而未及时更新，或有任何误导之嫌，导致我们无法为您提供或进一步提供平台服务等情况时，我们将不承担任何责任。
                        <br>2.修改资料
                        <br>您可以在任何时候，通过我们官方网站提供的平台服务或我们公布的其他途径，更新或修改您所提供的资料。
                        <br>3.个人资料的披露
                        <br>为了向您提供平台服务，您同意授权我们以我们认为适当的方式向第三方透露您的资料。但是，我们不会公开您的姓名、住址、通讯地址、电子邮箱、账号、密码等个人资料。除非：      
                        <br>（1）您允许我们披露这些个人资料；
                        <br>（2）部分服务需要将资料提供第三方进行比对确认；
                        <br>（3）有关法律法规或行政规章要求我们披露您的个人资料；
                        <br>（4）司法机关或行政机关基于法定程序要求我们披露您的个人资料；
                        <br>（5）为保护我们的知识产权和其他财产权益，需要披露您的个人资料；
                        <br>（6）在紧急情况下为保护其他用户和社会大众的人身安全，需要披露您的个人资料。
                        <br>我们将采取商业上合理的方式以保护您的个人资料的安全。我们将使用通常可以获得的安全技术和程序来保护您的个人资料不被未经授权的访问、使用或泄漏。对于非因我们的疏忽而造成您账号的丢失或您个人资料的泄密，我们不承担任何责任。</div><br>
                    
                    <div class="title">三、关于账号</div>
                    <div class="title" style="margin-top: 10px;">&emsp;此处指的是您注册成功的账号。请了解账号在注册之后不可变更。您对于您的账号的保管以及使用该账号所进行的一切行动负有完全的责任。请不要将账号转让或出借给他人使用。因为您的保管疏忽或其他任何个人行为导致您的账号遭他人非法使用及因此所衍生的任何后果，我们不承担任何责任。为促进平台健康发展，当您的钱大师账户超过（含）180自然日未登录时，我们有权在不通知您的情况下清空您钱大师账户上的全部信息，包含但不限于账户及余额。</div><br>
                
                    <div class="title">四、您的权利</div>
                    <div class="content">1.您可以根据本协议以及我们不时更新和公布的其他规则使用我们提供的平台服务。  
                        <br>2.您有权在使用我们提供的平台服务期间监督我们及我们的工作人员是否按照我们所公布的标准向您提供平台服务，也可以随时向我们提出与我们的平台服务有关的意见和建议。
                        <br>3.如果您不同意本协议条款，或对我们后来更新的条款有异议，或对我们所提供的平台服务不满意，您可以选择停止使用我们的平台服务。如果您选择停止使用我们的平台服务，则我们即不再对您承担任何义务和责任。</div><br>

                    <div class="title">五、您的义务</div>
                    <div class="content">1.您同意按照我们不时发布、变更和修改的本协议条款及其他规则接受并使用我们的平台服务，您不得通过不正当的手段或其他不公平的手段使用我们的平台服务或参与我们活动。
                        <br><span style="font-weight: bold;">2.您不得干扰我们正常地提供平台服务，包括但不限于：
                        <br>（1）攻击、侵入我们的网站服务器或使网站服务器过载；    
                        <br>（2）破解、修改我们提供的网页或客户端等程序；
                        <br>（3）攻击、侵入我们的平台服务器或服务器端程序或使服务器过载；
                        <br>（4）制作、使用、发布、传播任何形式的妨碍平台公平性的辅助工具或程序（外挂）；
                        <br>（5）利用程序的漏洞和错误（Bug）破坏平台的正常进行或传播该漏洞或错误（Bug)，包括但不仅限于：使用苹果共享账号、兑换码和第三方市场下载付费任务的,一台设备刷机或利用漏洞生成超过1个钱大师账号的,同一人多台设备使用多个钱大师账号的（"多个"的定义需根据情节严重性而具体判断），或利用苹果设备越狱或使用第三方助手多开程序的或利用规则漏洞反复刷取奖励及各类优惠券的。
                        <br>（6）不合理地干扰或阻碍他人使用我们所提供的平台服务。违规的账号将全部冻结、禁止提现且不允许解冻。我们将视情况的严重程度决定是否以法律途径进行追责。 
                        <br> 3.您必须独立保管好自己的账号信息，由于您的原因导致账号泄密而造成的后果均将由您自行承担。</span>
                        <br> 4.您仅能以一个单独的自然人的身份使用我们所提供的平台服务，您不能利用我们所提供的平台服务从事商业目的的活动，也不能利用我们的平台服务进行销售或其他商业目的的活动。     
                        <br> 5.您需对自己账号中的所有活动和事件负责。您须遵守有关互联网信息发布的有关法律、法规及通常适用的互联网一般道德和礼仪的规范，您将自行承担您所发布的信息内容的责任。</div><br>

                    <div class="title">六、隐私保护</div>
                    <div class="content">1.保护用户（特别是未成年人）的隐私是我们的一项基本政策，因此，若父母（监护人）希望未成年人（尤其是十岁以下子女）得以使用本服务，必须以父母（监 护人）名义申请注册，在接受本服务时，应以法定监护人身份加以判断本服务是否符合于未成年人。 我们保证不对外公开或向第三方（本协议第六条第2款所列情况除外）提供用户注册资料及用户在使用平台服务时存储在的非公开内容，但下列情况除外：
                        <br>（1）事先获得用户的明确授权； 
                        <br>（2）根据有关的法律法规要求； 
                        <br>（3）按照相关政府主管部门的要求；  
                        <br>（4）为维护社会公众的利益；      
                        <br>（5）为维护我们的合法权益。
                        <br>2.在不透露单个用户隐私资料的前提下，我们有权对整个用户数据库进行技术分析并对已进行分析、整理后的用户数据库进行商业上的利用。请你谅解，尽管对用户的隐私权保护做了极大的努力，但是仍然不能保证现有的安全技术措施使用户的技术信息等不受任何形式的损失。</div><br>
                
                    <div class="title">七、免责声明</div>
                    <div class="content" style="font-weight: bold">1. 钱大师平台不保证以下事宜：
                        <br>(1) 本服务将完全符合您的要求；
                        <br>(2) 本服务将不受干扰、及时提供、安全可靠或不会出错。
                        <br>2.用户明确同意其使用平台服务所存在的风险将完全由其自己承担；因其使用平台服务而产生的一切后果也由其自己承担，对用户不承担任何责任。
                        <br>3.为了向您提供平台服务，我们可能会需要定期或不定期地对有关的平台服务器或我们所提供的平台服务的相关官方网站进行维护，该维护可能造成服务的中断，并且该中断可能没有事先的通知，对于由此引起的中断我们不承担任何责任。
                        <br>4.您已经了解并同意对于因我们、我们的合作方或电信网络系统软硬件设备的故障、失灵或人为操作的疏失而全部或部分中断、暂时无法使用、迟延并造成我们提供平台服务的停止或中断的，我们不承担任何责任；对于因他人侵入我们的网络或系统，篡改、删改或伪造、变造网站和资料或数据而造成我们的平台服务的停止或中断，我们也不承担任何责任。</div><br>
                
                    <div class="title">八、服务变更、中断或终止</div>
                    <div class="content">1.如因系统维护或升级的需要而需暂停平台服务，将尽可能事先进行通告。
                        <br>2.如发生下列任何一种情形，有权随时中断或终止向用户提供本协议项下的平台服务而无需通知用户：
                        <br>(a) 用户提供的个人资料不真实；
                        <br>(b) 用户违反本协议中规定的使用规则。      
                        <br>3.除前款所述情形外，同时保留在不事先通知用户的情况下随时中断或终止部分或全部平台服务的权利，对于所有服务的中断或终止而造成的任何损失，无需对用户或任何第三方承担任何责任。</div><br>
                    
                    <div class="title">九、服务中断、停止和变更的说明</div>
                    <div class="content">&emsp;发生下列情形之一时，我们有权中断、停止或变更我们提供的服务，对于因此而产生的困扰、不便或损失，我们不承担任何责任：
                        <br>1.定期检查或施工，软硬件更新等，即暂停服务，我们将尽快完成维修、维护工作。
                        <br>2.服务器遭到任何形式的破坏，无法正常运作。
                        <br>3.网络线路或其它导致用户通过Internet连接至我们服务器的动作发生滞碍等情形。
                        <br>4.自然灾害等不可抗力的因素。
                        <br>5.在紧急情况之下为维护国家安全或其它会员及第三者人身安全时。
                        <br>6.发生突发性软硬件设备与电子通信设备故障时。</div><br>

                    <div class="title">十、个人资料的转移和服务方式的转变</div>
                    <div class="content">&emsp;我们将尽力持续地向您提供平台服务，但是我们并不排除我们可能会停止提供该平台服务的可能性，也不排除任何改变服务方式的可能性。如果我们停止或改变提供平台服务，我们将会事先通知您，并尽力寻找适当的服务提供者或方式以代替我们继续提供平台服务。在这种情况下，我们可能会将您的个人资料（包括有关的账号和密码信息及个人资料）转移给该继续提供服务的一方，也可能根据需要永久封存原有资料以推行新的服务方式。您在此同意我们有权做此转移和改变，并且同意在我们完成转移和改变之后，我们即不再对您原有资料承担任何义务和责任。但是，我们并不在此保证我们届时肯定能够找到适当的服务提供者或服务方式以 代替我们继续提供平台服务，也不保证我们找到的服务提供者所提供的平台服务以及改变的服务方式能够满足您的要求。</div><br>
                
                    <div class="title">十一、资费政策及提现</div>
                    <div class="content" style="font-weight: bold;">我们将有权决定我们所提供的平台服务的资费标准和提现方式，我们可能会就不同的平台服务制定不同的资费标准和提现方式，也可能按照我们所提供的平台服务的不同阶段确定不同的资费标准和提现方式。另外，我们也可能不时地修改我们的资费和提现政策。我们会将有关平台服务的的资费标准、提现方式或其他有关政策的信息放置在该平台服务相关网页的显著位置。</div><br>
                
                    <div class="title">十二、版本更新变动的说明</div>
                    <div class="content">为增加并丰富产品的内容，我们在运行时会不定期更新并调整改变产品内所有的功能。在产品更新后，一切产品内的操作、内容、设定将以产品中的公告设定为准。</div><br>

                    <div class="title">十三、责任限制及不可抗力</div>
                    <div class="content"><span style="font-weight: bold;">1.在法律法规所允许的限度内，因您使用平台服务而引起的任何损害或经济损失，我们承担的全部责任均不超过就用户使用平台所产生的直接收益。这些责任限制条款将在法律所允许的最大限度内适用，并在用户账户被注销后仍继续有效。
                        <br>2.我们仅限在“按现状”和“按现有”的基础上，向用户提供全部的信息、内容、材料、产品（包括软件）和服务。除非另有明确的书面说明，我们不对其包含在本网上的信息、内容、材料、产品（包括软件）或服务作任何形式的、明示或默示的担保。</span>
                        <br>3.对于因病毒、系统缺陷、人对计算机系统的作为或不作为、电话线、硬件、软件、程序出错或其它由于使用平台而引起的计算机传输或网络连接错误、失败或延迟造成的损害，我们不承担责任。
                        <br>4.不论在任何情况下，我们均不对由于互联网设备正常维护，互联网络连接故障，电脑、通讯或其他系统的故障，电力故障，罢工，暴乱，骚乱，灾难性天气（如火灾、洪水、风暴等），爆炸，战争，政府行为，司法行政机关的命令或第三方的不作为而造成的不能履行或延迟履行承担责任。</div><br>

                    <div class="title">十四、平台管理</div>
                    <div class="content"><span style="font-weight: bold;">1. 用户守则
                        <br>（1）遵守国家法律法规；
                        <br>（2）严禁修改、破译或进行任何影响程序和网络数据传输封包的行为；
                        <br>（3）严禁使用任何方法对服务器进行恶意入侵、攻击，或任何破坏平台服务正常运行的行为；
                        <br>（4）禁止利用Bug和第三方外挂程序进行获利、破坏平台公平性及造成服务器负担加重的行为；
                        <br>（5）禁止公开或私下传播任何存在并可利用的Bug，请在发现该类问题时立即向我们反映；
                        <br>（6）禁止使用含有人身攻击、淫秽、辱骂、反动及其他危害本产品及平台形象、扰乱正常服务秩序以及国家利益和社会公德性质的昵称名；
                        <br>（7）任何侵犯以上条款的违规行为， 钱大师有权根据情节轻重对违规者进行警告、禁闭、改名、直至删除账号的处罚，情节尤其严重者，将进一步追究法律责任，由于违规造成的损失和后果，由当事的 钱大师使用者自行承担；</span></div><br>

                    <div class="title">十五、用户管理</div>
                    <div class="content">用户独立承担其发布内容的责任。用户对服务的使用必须遵守所有适用于服务的地方法律、国家法律和国际法律。用户承诺：<span style="font-weight: bold;">1、用户在我们的网页上及其他平台中发布信息或者利用我们提供的服务时必须符合中国有关法规，不得在我们的网页或者其他网页及平台中利用我们提供的服务制作、复制、发布、传播以下信息：
                        <br>（1）反对宪法所确定的基本原则的;
                        <br>（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的;
                        <br>（3）损害国家荣誉和利益的;
                        <br>（4）煽动民族仇恨、民族歧视，破坏民族团结的;
                        <br>（5）破坏国家宗教政策，宣扬邪教和封建迷信的;
                        <br>（6）散布谣言，扰乱社会秩序，破坏社会稳定的;
                        <br>（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的;
                        <br>（8）散步广告、垃圾信息，影响平台秩序的。
                        <br>（9）侮辱或者诽谤他人，侵害他人合法权益的;
                        <br>（10）煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的;
                        <br>（11）以非法民间组织名义活动的;
                        <br>（12）含有法律、行政法规禁止的其他内容的。
                        <br>（13）侵犯任何第三者的知识产权，版权或公众/私人权利的。
                        <br>（14）违反人文道德、风俗习惯的。
                        <br>2、用户不得利用我们提供的服务从事以下活动：
                        <br>（1）未经允许，进入计算机信息网络或者使用计算机信息网络资源的;
                        <br>（2）未经允许，对计算机信息网络功能进行删除、修改或者增加的;
                        <br>（3）未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加的;
                        <br>（4）故意制作、传播计算机病毒等破坏性程序的;
                        <br>（5）其他危害计算机信息网络安全的行为。
                        <br>3、用户不得以任何方式干扰我们提供的服务。
                        <br>4、用户应遵守我们的所有其他规定和程序。
                        <br>用户须对自己在使用我们提供的服务过程中的行为承担法律责任。用户承担法律责任的形式包括但不限于：对受到侵害者进行赔偿，以及在我们首先承担了因用户行为导致的行政处罚或侵权损害赔偿责任后，用户应给予我们等额的赔偿。用户理解，如果我们发现其网站传输的信息明显属于上段第1条所列内容之一，依据中国法律，我们有义务立即停止传输，保存有关记录，向国家有关机关报告，并且删除含有该内容的地址、目录或关闭服务器。</span>
                        <br>5、保障
                        <br>用户同意保障和维护我们全体成员的利益，负责支付由用户使用超出服务范围引起的律师费用，违反服务条款的损害补偿费用，其它人使用用户的手机、账号而产生的费用。用户或者使用用户账号的其他人在使用钱大师提供的平台服务过程中侵犯第三方知识产权及其他权利而导致被侵权人索赔的，由用户承担责任。</div><br>

                    <div class="title">十六、风险承担</div>
                    <div class="content"><span style="font-weight: bold;">您同意使用我们提供的产品及服务是出于您的个人意愿，并愿自负任何风险，包括但不限于您因执行我们所提供的服务程序或自行由官方网站下载软件而导致您或您所使用的计算机系统受到损害或发生任何资料的流失等。
                        <br>注意：玩家个人操作导致出错的任何结果，由玩家自行负责，我们不给予任何形式的赔偿！</span></div><br>

                    <div class="title">十七、损害赔偿</div>
                    <div class="content">您若违反本协议或相关法令，导致我们的母公司、子公司、附属公司、关系企业、受雇人、代理人及其他一切相关履行辅助人员因此受到损害或支出一切衍生费用（包括但不限于支付上述人士须就您的违反行为所进行的一切辩护或索偿诉讼及相关和解之法律费用），您应负担损害赔偿及费用承担责任。</div><br>

                    <div class="title">十八、公司拥有终止权</div>
                    <div class="content"><span style="font-weight: bold;">您应确实遵守本协议及有关法律命令的规定。我们对于您是否违反本协议拥有最终决定权。若我们认定您违反本协议或任何法令，我们有权在无需向您进行事先通知的情况之下，立即暂停及终止或删除您账号与您账号中的所有相关资料、档案及任何记录，以及取消、停止、限制您的用户资格。</span></div><br>

                    <div class="title">十九、关于广告</div>
                    <div class="content">我们的线上软件可能刊登商业广告或其它活动促销的广告。这些内容系广告商或商品服务提供者所为，我们仅提供刊登内容的媒介。您通过我们或我们所链接的网站所购买的服务或商品，其交易行为仅存于您与该商品或服务的提供者之间，与我们无关。</div><br>

                    <div class="title">二十、至第三方站点的链接</div>
                    <div class="content">您可能在使用我们的平台服务过程中链接到第三方的站点。第三方的站点不由我们控制，并且我们也不对任何第三方站点的内容、第三方站点包含的任何链接、或第三方站点的任何更改或更新负责。我们仅为了提供便利的目的而向您提供这些到第三方站点的链接，我们所提供的这些链接并不意味着我们认可该第三方站点。您需要自行检查并遵守该第三方站点的相关规定。<span style="font-weight: bold;"></span></div><br>

                    <div class="title">二十一、与法律的冲突</div>
                    <div class="content">本协议的解释、效力及适用以中华人民共和国大陆地区法律为依据。如果本协议的任何内容与法律相抵触，应以法律规定为准。<span style="font-weight: bold;"></span></div><br>

                    <div class="title">二十二、个别条款的效力</div>
                    <div class="content">本协议所定的任何条款的一部或全部无效者，不影响其它条款的效力。<span style="font-weight: bold;"></span></div><br>

                    <div class="title">二十三、本协议的签订地点为中华人民共和国重庆市沙坪坝区。</div>

                    <div class="title">二十四、知识产权</div>
                    <div class="content">1.钱大师平台所包含的全部智力成果包括但不限于数据库、网站设计、文字和图表、软件、照片、录像、音乐、声音及其前述组合，软件编译、相关源代码和软件(包括小应用程序和脚本)的知识产权权利均归我们所有，受中国和国际版权法的保护。平台上所有内容的汇编是我们的拥有排他性权利的财产，受中国和国际版权法的保护。
                        <br>2.未经我们授权,您不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取或以其他方式使用平台的信息内容，否则，我们有权追究其法律责任。
                        <br>3.您接受本协议即视为您主动将其在钱大师平台发表的任何形式的信息的著作权，包括但不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他可转让权利无偿独家转让给我们所有，我们有权利就任何主体侵权单独提起诉讼并获得全部赔偿。本协议属于《中华人民共和国著作权法》第二十五条规定的书面协议，其效力及于用户在本网发布的任何受著作权法保护的作品内容，无论该内容形成于本协议签订前还是本协议签订后。<span style="font-weight: bold;"></span></div><br>

                </div>

                <img src="../../assets/images/img_52.png" alt="" id="bgs">
            </div>
        </div>
    </div>
</template>

<script>
    import Headers from '../../components/headers.vue'
    export default {
        components:{
            Headers
        },
        data() {
            return {
                headersText:'钱大师打款服务协议',
            }
        },
        methods: {
            
        },
    }
</script>

<style lang="less" scoped>
    #aboutCashOut{
        .boxPadding{
            padding: 15px;
            .explain{
                width: 345px;
                background: #FFFFFF;
                border-radius: 5px;
                border: 1px solid #DEDEDE;
                position: relative;
                .text{
                    margin: 15px;
                    color: #111111;
                    font-size: 13px;
                    line-height: 18px;
                    .title{
                        font-weight: bold;
                        &:not(:first-of-type){
                            margin-top: 15px;
                        }
                    }
                    .content{
                        font-size: 13px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #111111;
                        line-height: 22px;
                    }
                }
                #bgs{
                    width: 176px;
                    height: 189px;
                    position: absolute;
                    right: 20px;
                    bottom: 20px;
                }
            }
        }
        
    }
</style>